import   React                            ,
       { useState                         ,
         useEffect                        ,
         useRef                           }  from "react";

import   classNames                          from "classnames";

import   styles                              from "./PaymentFrame.module.scss";


import { convertDateToString              ,
         convertStringToDate                   }  from '../../../../dataTypes/timeManagment/utils';

import { groupData                        ,
         GroupedData                      ,
         initializedGroupedData                }  from "../../../../dataTypes/dataSetManagment/regroupData";

import   TabularDisplay                      from "../../../widget/dataDisplay/tables/TabularDisplay";
import   ExtendablePanel                     from "../../../widget/windows/ExtendablePanel";
import   Select                              from '../../../widget/inputs/Select';
import   AnimatedWaitingIcon                 from '../../../widget/animations/animatedWaitingIcon';
import   Field                               from '../../../widget/inputs/Field';
import   Box                                 from '../../../widget/windows/Box';

import   UserInformations2                   from '../../userManagment/UserInformations2'

import { GetPaymentListParams             ,
         EnrichedPayment                  }  from "../../../../dataTypes/paymentManagment/types";

import { getEnrichedPaymentList           }  from "../../../../backendServices/paymentManagment/api";


export interface EnrichedPayment2 extends EnrichedPayment {

  userId: number;
  userEmail: string;
  userFirstname: string;
  userLastname: string;
}

const PaymentFrame: React.FC = () => {

  const periodNames: string[] = [ "Jour courant"  , "Semaine courante" , "Mois courant"   , "Personnaliser"    ]

  const now = new Date();

  // 1 heure glissante 

  // 7 jours glissants (le jour courant étant le dernier jour)
  const rollingWeekStart   = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 6, 0, 0, 0);
  const rollingWeekEnd     = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

  // Mois courant
  const currentDayStart    = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const currentDayEnd      = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);

  // Mois courant
  const currentMonthStart  = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
  const currentMonthEnd    = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59);

  // Mois précédent

  // Année courante (du 1er janvier jusqu'à aujourd'hui)

  // Année précédente (du 1er janvier au 31 décembre)

  const [ showWaitingIcon          , setShowWaitingIcon          ] = useState(false);

  const [ selectedPeriod           , setSelectedPeriod           ] = useState (periodNames[0])
  const [ selectedPeriodIndex      , setSelectedPeriodIndex      ] = useState (0)
  const [ periodStartDate          , setPeriodStartDate          ] = useState<Date> ( currentDayStart );
  const [ periodEndDate            , setPeriodEndDate            ] = useState<Date> ( currentDayEnd );
  
  const [ data                     , setData                     ] = useState<EnrichedPayment[]> ( [] )
  const [ groupedData              , setGroupedData              ] = useState<GroupedData<EnrichedPayment2>>(initializedGroupedData<EnrichedPayment2>())

  const [ userToShow               , setUserToShow               ] = useState (0);

  const [ componentHeight          , setComponentHeight          ] = useState (380);
  const [            , setComponentWidth           ] = useState (560);
  const [            , setComponentReady           ] = useState (false);
  
  const [ dataSectionHeight        , setDataSectionHeight        ] = useState (380);
  const [          , setDataSectionWidth         ] = useState (560);
  const [ tableHeight              , setTableHeight              ] = useState (300);

  const dataSectionRef = useRef<HTMLDivElement | null>(null);
  const componentRef   = useRef<HTMLDivElement | null>(null);

  const intervalRef    = useRef<NodeJS.Timeout | null>(null);

  const fetchData = async () => {
	  
    try 
	 {
      setShowWaitingIcon(true);

      const paymentParams : GetPaymentListParams = {
          beginningDate : periodStartDate,
          endingDate    : periodEndDate
      };

      const paymentsResult = await getEnrichedPaymentList(paymentParams);

      if (paymentsResult.code === 1) {
            
        setData (paymentsResult.payload);
      }
     } 
	catch (error) 
	 {
      console.error("Erreur lors de la récupération des sessions :", error);
      setShowWaitingIcon(false);
     }
  };

  useEffect(() => {

    fetchData(); 

    intervalRef.current = setInterval(fetchData, 60000); // 60000 milliseconds = 1 minute

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Nettoyage de l'intervalle lors du démontage du composant
      }
    };
  }, [periodStartDate, periodEndDate ]);

  useEffect(() => {
	  
    const data2: EnrichedPayment2[] = data.map(payment => ({
          ...payment,
          userId           : payment.purchase?.userId ?? 0, // Assurez-vous que purchase et userId existent
          userEmail        : payment.purchase?.user?.email ?? "", // Assurez-vous que purchase et userId existent
          userFirstname    : payment.purchase?.user?.firstname ?? "", // Assurez-vous que purchase et userId existent
          userLastname     : payment.purchase?.user?.lastname ?? "", // Assurez-vous que purchase et userId existent
        }));

    let groupKey = (payment: EnrichedPayment2) => ({
      key: `${convertDateToString(payment.creationDate, "yyyy/MM/dd")}`,
      renderer: (val: string) => `${convertDateToString(convertStringToDate(val, "yyyy/MM/dd"), "dd/MM/yyyy")}`
    });

    if (selectedPeriodIndex > 1) {
      groupKey = (payment: EnrichedPayment2) => ({
        key: `${convertDateToString(payment.creationDate, "yyyy/MM")}`,
        renderer: (val: string) => `${convertDateToString(convertStringToDate(val, "yyyy/MM"), "MMMM yyyy")}`
      });
    }

    const groupedDataLocal = groupData<EnrichedPayment2>(data2, groupKey);

    setGroupedData(groupedDataLocal); 

    setShowWaitingIcon(false);
	
  }, [data]);


  const updateDataSectionDimensions = () => {
        
    if (dataSectionRef.current) 
     {
      const newHeight = dataSectionRef.current.clientHeight;
      const newWidth  = dataSectionRef.current.clientWidth;
        
      setDataSectionHeight(newHeight);
      setDataSectionWidth (newWidth );
     }
  };

  useEffect(() => {
      
    const resizeObserver = new ResizeObserver(() => {
      updateDataSectionDimensions()
    });

    if (dataSectionRef.current) 
     {
      resizeObserver.observe(dataSectionRef.current);
      updateDataSectionDimensions();
     }

    if (componentRef.current) 
     {
      resizeObserver.observe(componentRef.current);
      const newHeight = componentRef.current.clientHeight;
      const newWidth  = componentRef.current.clientWidth;
        
      setComponentHeight (newHeight);
      setComponentWidth  (newWidth );
      setComponentReady  (true );
     }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);
 
  useEffect(() => {

    const resizeObserver = new ResizeObserver(() => {
      updateDataSectionDimensions();
    });

    if (dataSectionRef.current) 
     {
      resizeObserver.observe(dataSectionRef.current);
      updateDataSectionDimensions();
     }

    return () => {
      resizeObserver.disconnect();
    };
  }, [dataSectionRef.current]);

  useEffect(() => {
      
    if (dataSectionHeight > 0) 
     {
      setTableHeight (dataSectionHeight - 100);
     }
  }, [dataSectionHeight]);

  const handleStateChange = (isFullScreen: boolean) => {
      
    updateDataSectionDimensions ()
  }


  const handlePeriodChange = (e: React.ChangeEvent<HTMLSelectElement>) => {

    console.log ( 'handlePeriodChange', e.target.selectedIndex-1)

    setSelectedPeriod      (e.target.value);
    setSelectedPeriodIndex (e.target.selectedIndex-1);

    switch ( e.target.selectedIndex-1 )
     {
      case 0 : // Jour courant

               setPeriodStartDate(currentDayStart);
               setPeriodEndDate(currentDayEnd);
               break;
      case 1 : // Semaine courante

               setPeriodStartDate(rollingWeekStart);
               setPeriodEndDate(rollingWeekEnd);
               break;

      case 2 : // Mois courant

               setPeriodStartDate(currentMonthStart);
               setPeriodEndDate(currentMonthEnd);
               break;
     }
  };

  const handlePeriodStartDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate, "dd/MM/yyyy")

    if (convertedDate)
          {
           setPeriodStartDate(convertedDate);
          }
     else {
           console.error("Invalid date format received");
          }
  }

  const handlePeriodEndDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {

    const newDate: string = event.target.value;
    const convertedDate = convertStringToDate(newDate, "dd/MM/yyyy");

    if (convertedDate)
          {
           setPeriodEndDate(convertedDate);
          }
     else {
           console.error("Invalid date format received");
          }
  }

  const handleSpanClick = (userId:number) => {
      
    setUserToShow (userId)
  }
  
  const handleClose = () => {
      
    setUserToShow (0)
  }
  
  const renderTable = () : JSX.Element => {

    const columns = [
       {
        header       : "Référence"                         ,
        accessor     : "paymentReference" as keyof EnrichedPayment2 ,
        width        : '110px'                             ,
       },
	   { 
	    header       : "UserId" , 
		accessor     : "userId" as keyof EnrichedPayment2 , 
		width        : '70px'  , 
		cellRenderer : (value: any) => (<span onClick={() => handleSpanClick(value)} style={{ textDecoration: 'underline'  , cursor: 'pointer' }}>{value}</span>) 
       },
       {
        header       : "Montant"                           ,
        accessor     : "amount" as keyof EnrichedPayment2 ,
        width        : '85px'                             ,
        cellRenderer : (value: any) => (<span>{ ( (value as number) / 100 ).toFixed(2) } €</span>)
       },
       {
        header       : "Statut"                            ,
        accessor     : "status" as keyof EnrichedPayment2 ,
        width        : '62px'                             ,
        cellRenderer : (value: any) => (<span>{ (value as string) === 'Paid' ? 'Payé' : 'Echec' }</span>)
       },
       {
        header       : "Date de paiement"                  ,
        accessor     : "creationDate" as keyof EnrichedPayment2 ,
        width        : '150px'                             ,
        cellRenderer : (value: any) => (<span>{value.toLocaleString()}</span>)
       },
	   { 
	    header: "Moyen de paiement" , 
	    accessor: "meansOfPayment"     as keyof EnrichedPayment2 , 
	    width: '150px' 
       }
    ];

    return (
    	    <>
              <ExtendablePanel height        = {componentHeight} 
			                   ref           = {dataSectionRef} 
							   onStateChange = {handleStateChange}
							   logoPosition  = 'upperRight' >
       
                <h2 className={styles.title}>Commandes</h2>
                <div className={classNames(styles.periodChoice)}>
                  <Select choices  = {periodNames}
                          value    = {selectedPeriod}
                          onChange = {handlePeriodChange} />
                  {
                   selectedPeriod === periodNames[3] &&
				   (
                    <div className={classNames(styles.periodChoice2)}>
                      <Field value     = {periodStartDate ? convertDateToString (periodStartDate, "dd/MM/yyyy") : ''}
                             onChange  = {handlePeriodStartDateChange}
                             type      = "calendar"  />
                      <Field value     = {periodEndDate ? convertDateToString (periodEndDate, "dd/MM/yyyy") : ''}
                             onChange  = {handlePeriodEndDateChange}
                             type      = "calendar"  />
                    </div>
				   )
                  }
                </div>

                <div className={styles.wrapper} >
                  <div className={styles.container} style={{maxHeight: tableHeight}} > 
                    {
                     groupedData.groups.size > 0
                     ?
                     (
                      <TabularDisplay groupedData       = { groupedData }
                                      columns           = { columns }
                                      groupDisplayOrder = 'reverse'
  onRowClick={(row) => console.log(row)}
  highlightClickableRows={true}
  getRowTextColor   = { (row) => {
                                                                       if ( row.status === "Fail" || row.status === "New" )
                                                                        {
                                                                         return "red";
                                                                        }
                                                                       return undefined;
                                                                     }
                                                          } />
                     )
                     :
                     (
                      <div className={styles.noData}>Aucune donnée pour<br/>la période considérée</div>
                     )
                    }
                  </div>
                </div>
				
              </ExtendablePanel>

            </>
		   )
  }

  return (
    
      <div ref={componentRef} className={classNames(styles.root)}>

        {
         userToShow !== 0 &&
         (
          <Box width="95vw" height="95vh" onClose={handleClose} logo={true}>
            <UserInformations2 userId={userToShow} />
          </Box>
         )
        }
	  
        <div className={classNames(styles.overlay)}>
		  {showWaitingIcon && <AnimatedWaitingIcon />}
        </div>
	  
        {renderTable()}
		
      </div>

  );
};

export default PaymentFrame;
